import { render, staticRenderFns } from "./licenseCard.vue?vue&type=template&id=534e89a7&scoped=true&"
import script from "./licenseCard.vue?vue&type=script&lang=js&"
export * from "./licenseCard.vue?vue&type=script&lang=js&"
import style0 from "./licenseCard.vue?vue&type=style&index=0&id=534e89a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534e89a7",
  null
  
)

export default component.exports